<template>
  <div class="container mt-4">
    <h1 class="text-center mb-4 fw-bold text-white title-gradient p-3 rounded">
      Tax Rules
    </h1>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex gap-2 mx-auto">
        <input type="text" v-model="searchState" class="form-control" placeholder="Search by State" />
        <input type="text" v-model="searchCategory" class="form-control" placeholder="Search by Category" />
      </div>

      <div v-if="loader" class="text-center my-4 loader-overlay">
        <div class="fancy-loader"></div>
      </div>

      <button class="btn btn-warning ms-auto" @click="showModal">Add Tax Rule</button>
    </div>
    <p v-if="!filteredTaxRules.length" class="text-danger text-center mt-3">
      No tax rules found.
    </p>
    <br /><br />
    <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
      <div class="col" v-for="i in paginatedTaxRules" :key="i.id">
        <div class="card shadow-lg border-0 bg-lightblue text-white hover-card h-100">
          <div class="card-body d-flex flex-column justify-content-between text-center">
            <div>
              <h6 class="card-title text-warning">
                Tax Formula: {{ formatTaxFormula(i.tax_formula) }}
              </h6>
            <p class="card-text" v-if="['sales_price', 'cost_price'].includes(i.tax_formula)">
            <strong>Percentage:</strong> {{ i.tax_percentage }}%
            </p>
           <p class="card-text" v-if="['mili_liter_liquid','per_pack','lsu_factor'].includes(i.tax_formula)">
             <strong>Per Unit:</strong> {{ i.tax_per_unit }}
          </p>
              <p class="card-text"><strong>State:</strong> {{ i.state_name }}</p>
              <p class="card-text"><strong>Category:</strong> {{ i.category_name }}</p>
            </div>
            <div class="d-flex gap-3 mt-3">
              <button class="btn btn-warning w-50 px-3 py-1" @click="editTaxRule(i)">
                Edit
              </button>                                                  
              <button @click="openModal1(i)" class="btn btn-danger w-50 px-3 py-1">
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-container text-center mt-3">
      <button class="btn btn-secondary me-2" @click="prevPage" :disabled="currentPage === 1">
        Previous
      </button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button class="btn btn-secondary ms-2" @click="nextPage" :disabled="currentPage === totalPages">
        Next
      </button>
    </div>
    <div class="modal fade" id="addRuleModal" tabindex="-1" aria-labelledby="addRuleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered custom-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Tax Rule</h5>
            <div v-if="addRuleloader" class="add-rule-loader-overlay">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 text-primary">Submitting Tax Rule, please wait...</p>
            </div>

            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
            </div>
            <form @submit.prevent="AddRulesData">
              <div class="row g-2">
                <div class="col">
                  <label class="form-label">State</label>
                  <select v-model="state" class="form-control" required>
                    <option value="" disabled>Select a State</option>
                    <option v-for="st in filteredStates" :key="st.id" :value="st.id">
                      {{ st.name }}
                    </option>
                  </select>
                </div>
                <div class="col">
                  <label class="form-label">Category</label>
                  <select v-model="category" class="form-control">
                    <option value="" disabled>Select a Category</option>
                    <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                      {{ cat.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">Tax Formula</label>
                <select v-model="tax_formula" class="form-control" @change="handleFormulaChange" required>
                  <option value="" disabled>Select Tax Formula</option>
                  <option value="mili_liter_liquid">Mili Liter Liquid</option>
                  <option value="cost_price">Cost Price</option>
                  <option value="sales_price">Sales Price</option>
                  <option value="lsu_factor">LSU Factor</option>
                  <option value="per_pack">Per Pack</option>
                </select>
              </div>

              <div class="row g-2">
                <div class="col">
                  <label class="form-label">Tax Percentage</label>
                  <input type="number" v-model="tax_percentage" class="form-control" :disabled="disablePercentage"
                    placeholder="Enter value" @blur="convertEmptyToZero" step="any" />
                    <small v-if="ValidateRulesError.tax_percentage" class="text-danger"> {{ ValidateRulesError.tax_percentage }}</small>
                </div>
                <div class="col">
                  <label class="form-label">Tax Per Unit</label>
                  <input type="number" v-model="tax_per_unit" class="form-control" :disabled="disablePerUnit"
                    placeholder="Enter value" @blur="convertEmptyToZero" step="any" />
                    <small v-if="ValidateRulesError.tax_per_unit" class="text-danger"> {{ ValidateRulesError.tax_per_unit }} </small>
                </div>
              </div>
              <button type="submit" class="btn btn-primary w-100 mt-3">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade small-modal" id="successModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content text-center">
          <div class="modal-header">
            <h6 class="modal-title text-success m-0">Success!</h6>
          </div>
          <div class="modal-body">
            <p class="m-0">{{ successMessage }}</p>
            <button type="button" class="btn btn-success btn-sm mt-2" data-bs-dismiss="modal"
              @click="clearSuccessMessage">
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="editRuleModal" tabindex="-1" aria-labelledby="editRuleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered custom-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit Tax Rule</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="successMessage" class="alert alert-success text-center">
              {{ successMessage }}
            </div>
            <div v-if="errorMessage" class="alert alert-danger text-center">
              {{ errorMessage }}
            </div>
            <form @submit.prevent="updateTaxRule">
              <div class="row g-2">
                <div class="col">
                  <label class="form-label">State</label>
                  <select v-model="editedRule.state" class="form-control" required>
                    <option value="" disabled>Select a State</option>
                    <option v-for="st in filteredStates" :key="st.id" :value="st.id">
                      {{ st.name }}
                    </option>
                  </select>
                </div>
                <div class="col">
                  <label class="form-label">Category</label>
                  <select v-model="editedRule.category" class="form-control">
                    <option value="" disabled>Select a Category</option>
                    <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                      {{ cat.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">Tax Formula</label>
                <select v-model="editedRule.tax_formula" class="form-control"
                  @change="handleEditFormulaChange(editedRule.tax_formula)" required>
                  <option value="" disabled>Select Tax Formula</option>
                  <option value="mili_liter_liquid">Mili Liter Liquid</option>
                  <option value="cost_price">Cost Price</option>
                  <option value="sales_price">Sales Price</option>
                  <option value="lsu_factor">LSU Factor</option>
                  <option value="per_pack">Per Pack</option>
                </select>
              </div>
              <div class="row g-2">
                <div class="col">
                  <label class="form-label">Tax Percentage</label>
                  <input type="number" v-model="editedRule.tax_percentage" class="form-control"
                    :disabled="disablePercentage" step="any" required />
                    <small v-if="Error.tax_percentage" class="text-danger"> {{ Error.tax_percentage }}</small>
                </div>
                <div class="col">
                  <label class="form-label">Tax Per Unit</label>
                  <input type="number" v-model="editedRule.tax_per_unit" class="form-control" :disabled="disablePerUnit"
                    step="any" required />
                    <small v-if="Error.tax_per_unit" class="text-danger"> {{ Error.tax_per_unit }}</small>
                </div>
              </div>
             
            <!--   <button 
               type="submit" 
               class="btn btn-primary w-100 mt-3"
              :disabled="addRuleloader"
             
              >
              <span v-if="addRuleloader">Update</span>
              <span v-else>Update</span>
             </button> -->
             <button
              class="btn btn-primary w-100 mt-3"
              :disabled="addRuleloader || !isRuleModified()">
               Update
               </button>

            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="logoutModal1" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirm Delete</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>
              Are you sure you want to delete Tax Rule according to this State :<strong>
                {{ selectedTaxRule?.state_name }},
              </strong>
              Category Name : <strong> {{ selectedTaxRule?.category_name }}?</strong>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
            <button class="btn btn-danger" @click="confirmDelete">Delete</button>
          </div>
          
          <div v-if="loader" class="text-center my-4 loader-overlay">
          <div class="fancy-loader"></div>
         </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import * as bootstrap from "bootstrap";
import {
  GetTaxRules,
  AddRules,
  DeleteTaxRulesdata,
  EditTaxRules,
} from "../End Points/api";
export default {
  data() {
    return {
      toastShown: false,
      data: [],
      state: "",
      selectedTaxRule: null,
      category: "",
      tax_formula: "",
      tax_per_unit: null,
      tax_percentage: null,
      currentPage: 1,
      itemsPerPage: 16,
      disablePercentage: true,
      disablePerUnit: true,
      errorMessage: "",
      editedRule: {},
      successMessage: "",
      searchState: "",
      searchCategory: "",
      loader: false,
      addRuleloader: false,
      Error: {},
      ValidateRulesError:{}
    };
  },
  computed: {
    ...mapState(["categories", "states"]),

    filteredStates() {
      return this.states.filter((st) => st.tax_applicable);
    },
    /*  filteredCategories() {
      return this.categories.filter((cat) => cat.is_active);
    }, */
    formattedTaxRules() {
      return this.data.map((rule) => {
        const categoryObj = this.categories.find((cat) => cat.id === rule.category);
        const stateObj = this.states.find((st) => st.id === rule.state);

        return {
          ...rule,
          category_name: categoryObj ? categoryObj.name : "Unknown Category",
          state_name: stateObj ? stateObj.name : "Unknown State",
        };
      });
    },
    filteredTaxRules() {
      return this.formattedTaxRules.filter((rule) => {
        const stateMatch = rule.state_name
          .toLowerCase()
          .includes(this.searchState.toLowerCase());
        const categoryMatch = rule.category_name
          .toLowerCase()
          .includes(this.searchCategory.toLowerCase());
        return stateMatch && categoryMatch;
      });
    },
    paginatedTaxRules() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredTaxRules.slice(start, start + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.filteredTaxRules.length / this.itemsPerPage);
    },
    noResults() {
      return this.filteredTaxRules.length === 0;
    },
  },
  watch: {
    searchState() {
      this.currentPage = 1;
    },
    searchCategory() {
      this.currentPage = 1;
    },
  },
  mounted() {
    this.GetTaxRuleData();
    this.$store.dispatch("fetchCategories");
    this.$store.dispatch("fetchStates");
    const modalEl = document.getElementById('addRuleModal');
  if (modalEl) {
    modalEl.addEventListener('shown.bs.modal', this.resetAddRuleForm);
  }
  },
  beforeUnmount() {
  const modalEl = document.getElementById('addRuleModal');
  if (modalEl) {
    modalEl.removeEventListener('shown.bs.modal', this.resetAddRuleForm);
  }
},
  methods: {
    resetAddRuleForm() {
    this.state = "";
    this.category = "";
    this.tax_formula = "";
    this.tax_percentage = 0;
    this.tax_per_unit = 0;
    this.disablePercentage = true;
    this.disablePerUnit = true;
    this.ValidateRulesError = {};
    this.errorMessage = "";
  },
    successToast(msg) {
      this.$toast.success(msg, { timeout: 4000 });
    },
    errorToast(msg) {
      this.$toast.error(msg, { timeout: 5000 });
    },
    async GetTaxRuleData() {
      this.loader = true;
      try {
        const res = await GetTaxRules();
        this.data = res.data;
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        this.loader = false;
      }
    },

    formatTaxFormula(formula) {
      return formula.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
    },
    //remmoving frontend validation 
   /*  ValidatetaxRulesData() {
  this.ValidateRulesError= {};

  const taxPercentage = this.tax_percentage?.toString();
  const taxPerUnit = this.tax_per_unit?.toString();

  const isValidValue = (val) => {
    const [beforeDecimal] = val.split(".");
    return beforeDecimal.length <= 5 && val.length <= 10;
  };


  if (parseFloat(taxPercentage) < 0) {
    this.ValidateRulesError.tax_percentage = "Tax percentage must not be negative.";
  } else if (!isValidValue(taxPercentage)) {
    this.ValidateRulesError.tax_percentage = "Tax percentage must have no more than 5 digits before the decimal and 10 characters total.";
  }


  if (parseFloat(taxPerUnit) < 0) {
    this.ValidateRulesError.tax_per_unit = "Tax per unit must not be negative.";
  } else if (!isValidValue(taxPerUnit)) {
    this.ValidateRulesError.tax_per_unit = "Tax per unit must have no more than 5 digits before the decimal and 10 characters total.";
  }

  return Object.keys(this.ValidateRulesError).length === 0;
}, */
    showModal() {
      var modal = new bootstrap.Modal(document.getElementById("addRuleModal"));
      this.errorMessage = "";
      this.successMessage = "";
      this.ValidateRulesError = {}
      this.clearForm();
      modal.show();
    },
  
    async AddRulesData() {
      this.addRuleloader = true;
      this.errorMessage = "";
      this.successMessage = "";
    /*   if (!this.ValidatetaxRulesData()) {
        this.addRuleloader = false
        return
      } */
      this.convertEmptyToZero();

      if (!this.state || !this.category || !this.tax_formula) {
        this.errorMessage = "All fields are required.";
        this.addRuleloader = false;
        return;
      }

      const exists = this.data.some(
        (rule) => rule.state === this.state && rule.category === this.category
      );

      if (exists) {
        this.errorMessage = "A tax rule for this state and category already exists.";
        this.addRuleloader = false;
        return;
      }

      if (["cost_price", "sales_price"].includes(this.tax_formula)) {
        if (this.tax_percentage <= -1) {
          this.errorMessage = "Tax percentage must be greater than or equal to 0.";
          this.addRuleloader = false;
          return;
        }
        this.tax_per_unit = 0;
      } else if (
        ["lsu_factor", "mili_liter_liquid", "per_pack"].includes(this.tax_formula)
      ) {
        if (this.tax_per_unit <= -1) {
          this.errorMessage = "Tax per unit must be greater than or equal to 0.";
          this.addRuleloader = false;
          return;
        }
        this.tax_percentage = 0;
      }

      try {
        const response = await AddRules({
          state: this.state,
          category: this.category,
          tax_formula: this.tax_formula,
          tax_per_unit: this.tax_per_unit,
          tax_percentage: this.tax_percentage,
        });

        this.successMessage = response.data.message || "Tax rule added successfully!";
        this.clearForm();
        this.GetTaxRuleData();
        var successModal = new bootstrap.Modal(document.getElementById("successModal"));
        successModal.show();
      }
      catch (error) {
  const data = error.response?.data || {};
  let messages = [];

  // Global errors
  if (Array.isArray(data.non_field_errors)) {
    messages.push(...data.non_field_errors);
  }

  if (typeof data.message === 'string') {
    messages.push(data.message);
  }

  // Field-specific errors with field names
  for (const key in data) {
    if (key !== 'non_field_errors' && key !== 'message') {
      const value = data[key];
      if (Array.isArray(value)) {
        value.forEach(msg => {
          messages.push(`${key.replace(/_/g, ' ')}: ${msg}`);
        });
      } else if (typeof value === 'string') {
        messages.push(`${key.replace(/_/g, ' ')}: ${value}`);
      }
    }
  }

  this.errorMessage = messages.length
    ? messages.join(' | ')  // join all with a separator like " | "
    : "Error adding tax rule.";

  console.error("the error is :", error);
}      
      finally {
      
        this.addRuleloader = false;
      }
    },
    convertEmptyToZero() {
      this.tax_per_unit =
        this.tax_per_unit === "" || this.tax_per_unit === null ? 0 : this.tax_per_unit;
      this.tax_percentage =
        this.tax_percentage === "" || this.tax_percentage === null
          ? 0
          : this.tax_percentage;
    },

    clearSuccessMessage() {
      this.successMessage = "";
    },

    handleFormulaChange() {
      if (["cost_price", "sales_price"].includes(this.tax_formula)) {
        this.disablePercentage = false;
        this.disablePerUnit = true;
        this.tax_per_unit = 0;
      } else if (
        ["lsu_factor", "mili_liter_liquid", "per_pack"].includes(this.tax_formula)
      ) {
        this.disablePercentage = true;
        this.disablePerUnit = false;
        this.tax_percentage = 0;
      } else {
        this.disablePercentage = true;
        this.disablePerUnit = true;
        this.tax_percentage = 0;
        this.tax_per_unit = 0;
      }
    },
    
    handleEditFormulaChange(selectedFormula) {
      if (!selectedFormula) {
        this.disablePercentage = true;
        this.disablePerUnit = true;

        return;
      }

      if (["cost_price", "sales_price"].includes(selectedFormula)) {
        this.disablePercentage = false;
        this.disablePerUnit = true;
      
      } else if (
        ["lsu_factor", "mili_liter_liquid", "per_pack"].includes(selectedFormula)
      ) {
        this.disablePercentage = true;
        this.disablePerUnit = false;
      
      } else {
        this.disablePercentage = true;
        this.disablePerUnit = true;
   
      }
    },

    clearForm() {
      this.state = "";
      this.category = "";
      this.tax_formula = "";
      this.tax_per_unit = 0;
      this.tax_percentage = 0;
      setTimeout(() => {
        this.errorMessage = "";
      }, 3000);
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },

    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    handleRuleDeleted(deletedId) {
      this.formattedTaxRules = this.formattedTaxRules.filter(
        (rule) => rule.id !== deletedId
      );
    },
    openModal1(rule) {
      this.selectedTaxRule = rule;
      const modal = new bootstrap.Modal(document.getElementById("logoutModal1"));
      modal.show();
    },
    async confirmDelete() {
      if (!this.selectedTaxRule) return;
      this.loader = true

      try {
        await DeleteTaxRulesdata(this.selectedTaxRule.id);
        this.data = this.data.filter((rule) => rule.id !== this.selectedTaxRule.id);
        this.filteredTaxRules = [...this.data]; 
        this.successToast("Tax Rule has been deleted successfully.")
       this.currentPage = Math.min(this.currentPage, this.totalPages || 1);
      } catch (error) {
        console.error("Error deleting tax rule", error);
      }
      finally {
         this.loader = false
      }
      const modal = bootstrap.Modal.getInstance(document.getElementById("logoutModal1"));
      modal.hide();
    },
/*     validateFieldTaxPercentageTaxPerUnit() {
  this.Error = {};

  const taxPercentage = this.editedRule.tax_percentage?.toString();
  const taxPerUnit = this.editedRule.tax_per_unit?.toString();

  const isValidValue = (val) => {
    const [beforeDecimal] = val.split(".");
    return beforeDecimal.length <= 5 && val.length <= 10;
  };


  if (parseFloat(taxPercentage) < 0) {
    this.Error.tax_percentage = "Tax percentage must not be negative.";
  } else if (!isValidValue(taxPercentage)) {
    this.Error.tax_percentage = "Tax percentage must have no more than 5 digits before the decimal and 10 characters total.";
  }


  if (parseFloat(taxPerUnit) < 0) {
    this.Error.tax_per_unit = "Tax per unit must not be negative.";
  } else if (!isValidValue(taxPerUnit)) {
    this.Error.tax_per_unit = "Tax per unit must have no more than 5 digits before the decimal and 10 characters total.";
  }

  return Object.keys(this.Error).length === 0;
}, */
isRuleModified() {
    return JSON.stringify(this.editedRule) !== JSON.stringify(this.originalEditedRule);
  },
    async updateTaxRule() {
      if (this.addRuleloader) return;
      this.loader = true
      this.addRuleloader = true
      this.errorMessage = "";
      this.successMessage = "";
   /*    if (!this.validateFieldTaxPercentageTaxPerUnit()) {
        return
      } */

      try {
        if (!this.editedRule || !this.editedRule.id) {
          /*       console.error("Error: editedRule.id is missing!", this.editedRule); */
          this.errorMessage = "Error: Missing tax rule ID.";
          return;
        }
        // checking from frontend while updating tax rules tax per unit and percentage never be 0 and negative values 
        if (["cost_price", "sales_price"].includes(this.editedRule.tax_formula)) {
          this.editedRule.tax_per_unit = 0;
          this.editedRule.tax_percentage = parseFloat(this.editedRule.tax_percentage) || 0;

          if (this.editedRule.tax_percentage <= -1) {
         this.errorMessage = "Tax percentage must be greater than or equal to  0.";
         return;
      }
        }
        else if (["lsu_factor", "mili_liter_liquid", "per_pack"].includes(this.editedRule.tax_formula)) {
        this.editedRule.tax_percentage = 0;
        this.editedRule.tax_per_unit = parseFloat(this.editedRule.tax_per_unit) || 0;

       if (this.editedRule.tax_per_unit <= -1) {
       this.errorMessage = "Tax per unit must be greater than or equal to  0.";
       return;
   }
        }
        else {
  this.errorMessage = ""; 
}


        const response = await EditTaxRules(this.editedRule.id, this.editedRule);

        if (response.status === 200) {
       
          const modalEl = document.getElementById("editRuleModal");
          const modalInstance = bootstrap.Modal.getInstance(modalEl);
          if (modalInstance) {
            modalInstance.hide();
          }
       
         /*  this.successMessage = "Tax rule updated successfully!"; */
          if (!this.toastShown) {
          this.successToast("Tax rule updated successfully!");
          this.toastShown = true;
          }

          this.showEditModal = false;
          await this.GetTaxRuleData();
        } else {
          this.errorMessage = "Failed to update tax rule.";
        }
      } catch (error) {
  console.error("Error Response:", error.response?.data);

  const errors = error.response?.data || {};
  let messages = [];

  for (const key in errors) {
    const value = errors[key];

    if (Array.isArray(value)) {
      value.forEach(msg => {
        const fieldName = key === 'non_field_errors' ? 'Error' : key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
        messages.push(`${fieldName}: ${msg}`);
      });
    } else if (typeof value === 'string') {
      const fieldName = key === 'non_field_errors' ? 'Error' : key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
      messages.push(`${fieldName}: ${value}`);
    }
  }

  this.errorMessage = messages.length
    ? messages.join(' | ') 
    : "An error occurred while processing the request.";
      }
      finally {
        
        setTimeout(() => {
          this.addRuleloader = false
          this.toastShown = false;
          this.loader = false
        }, 700);
       
}


    },
    editTaxRule(rule) {
      this.successMessage=""
      this.errorMessage = ""
      this.Error ={}
      console.log("Editing tax rule:", rule);
      this.editedRule = JSON.parse(JSON.stringify(rule)); // Deep copy
      this.handleEditFormulaChange(this.editedRule.tax_formula); // <-- Call here
      this.originalEditedRule = JSON.parse(JSON.stringify(rule)); // store original for comparison
      var modal = new bootstrap.Modal(document.getElementById("editRuleModal"));
      modal.show();
    },
  

  },
};
</script>

<style scoped>
#logoutModal1 .modal-content {
  height: auto;
  border-radius: 10px;
}

@media (max-width: 576px) {
  .custom-modal {
    margin: 1.5rem auto;
    max-width: 90% !important;
  }

  .custom-modal .modal-content {
    border-radius: 10px;
    padding: 1rem;
  }
}

.custom-modal {
  max-width: 700px;
  width: 90%;
  margin: 1.75rem auto;
}

.custom-modal .modal-content {
  max-height: 85vh;
  overflow-y: auto;
  border-radius: 10px;
  padding: 10px;
}

.modalheight {
  max-height: 64vh;
  overflow-y: auto;
}

.no-results {
  color: red;
  font-weight: bold;
  margin-top: 10px;
}

.modal-body1 {
  max-height: 150px;
  overflow-y: auto;
}

.fade-out {
  opacity: 1;
  transition: opacity 1s ease-in-out;
}

.fade-out.hide {
  opacity: 0;
}

.modal-xl {
  max-width: 60%;
  width: 60%;
}

.form-control {
  max-width: 400px;
  width: 100%;
}

.title-gradient {
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
}

.bg-lightblue {
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
  border-radius: 10px;
}

.hover-card {
  transition: all 0.3s ease-in-out;
}

.hover-card:hover {
  transform: scale(1.05);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);
}

.card-text {
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.search-input {
  width: 300px;
  height: 40px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  position: fixed;
}

.search-input:focus {
  border-color: #007bff;
  outline: none;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.fancy-loader {
  width: 60px;
  height: 60px;
  border: 6px solid #e0e0e0;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  animation: slow-spin 1.8s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
}

@keyframes slow-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.add-rule-loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  border-radius: 0.5rem;
}
</style>
